import { IContact } from "../generated/Api";

export interface IVirtualField {
  key: string;
  template: string;
  fields: string[];
  bypass?: boolean;
}

const SEPARATORS = ["(", ")", ".", ",", "|", "/", "-", "{", "}", ";", "—"];
const NFH = "~NFH!!"; // Nothing found here
const NFHRegex = /\~NFH\!\!/g;

export function parseVirtualField({
  field,
  contact,
}: {
  field: IVirtualField;
  contact: IContact;
}) {
  let values: { key: string; value: any }[] = [];

  values = Object.entries(contact).map(([key, value]) => {
    return {
      key: key.toLowerCase(),
      value,
    };
  });

  let answer = field.template;

  field.fields.map((f) => {
    const lowerF = f.toLowerCase();
    const item = values.find((x) => x.key === lowerF);
    const regex = new RegExp(`\{\{contact\.${lowerF}\}\}`, "gi");

    if (!item || item.value === "") {
      answer = answer.replace(regex, NFH); // Nothing found here!!
    } else {
      answer = answer.replace(regex, item.value);
    }
  });

  /**
   * Treatment for fields that doesn't exist
   */

  // Remove wrong extra lines
  let splitedAns = answer.split("\n");
  answer = splitedAns
    .filter((line) => {
      if (!line.includes(NFH)) return true;

      // See if the line has only ~NFH!!
      const splitedLine = line.split(NFH);

      let newLine = line;

      // Now check if all the texts are line breakers or such
      const passed = splitedLine.filter((text) => {
        let trimmedText = text.trim();
        if (!trimmedText) return false;
        if (SEPARATORS.includes(text)) return false;
        return true;
      });

      newLine = passed.join("");

      return !!newLine;
    })
    .join("\n");

  // Remove every separator that is in contact with a ~NFH!! -- like ~NFH!!,
  splitedAns = answer.split("\n");

  answer = splitedAns
    .map((line) => {
      if (!line.includes(NFH)) return line;

      // Separate the line by spaces
      let splitedLine = line.split(" ");

      // Now, map the splited words and search each of them for ~NFH!!
      splitedLine = splitedLine
        .map((word, index) => {
          if (word.includes(NFH)) return "";

          // Check if the word before or after the separator is NFH
          if (
            SEPARATORS.includes(word) &&
            ((index > 1 && splitedLine[index - 1] === NFH) ||
              (index < splitedLine.length - 1 &&
                splitedLine[index + 1] === NFH))
          )
            return "";

          return word;
        })
        .filter((word) => !!word);

      return splitedLine.join(" ");
    })
    .join("\n");

  // Remove all ~NFH!! from the text
  answer = answer.replace(NFHRegex, "");

  return answer;
}
